import  { useEffect } from 'react';
import './App.css';
import Aos from 'aos'
import 'aos/dist/aos.css'
import {    Link    } from "react-router-dom";
import   tayyab from "./images/IMG-20250513-WA0047.jpg";
import { motion } from 'framer-motion';

const Sidebar = () => {
 
    useEffect(()=>{
        Aos.init();
          },[])
           
          const handleDownload = () => {
            const link = document.createElement('a');
            link.href = `${process.env.PUBLIC_URL}/MdTayyab-Fullstack Developer 2026.pdf`;
            link.download = "MdTayyab-Fullstack Developer 2026.pdf"; 
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          };
    return (
      <div className="overflow-x-hidden elegant  font-medium ">
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.9,
            scale: { type: "spring", visualDuration: 0.6, bounce: 0.1 },
          }}
          className="md:block  hidden mx-auto bg-gradient-to-r from-gray-500 to-lime-800 container py-10 px-5 rounded-2xl  text-center"
        >
          <div className="profile-wrapper">
            {/* Rotating Border */}
            <motion.div
              className="profile-rotating-border"
              animate={{ rotate: 360 }}
              transition={{
                repeat: Infinity,
                duration: 6,
                ease: "linear",
              }}
            />

            {/* Static Image */}
            <div className="profile-image-holder">
              <img src={tayyab} alt="me" />
            </div>
          </div>

          <h2 className="Riesling md:text-3xl font-bold text-4xl py-8 birth">
            Md Tayyab
          </h2>
          <a href="mailto:tayyabmd00001@gmail.com" className=" py-8 ">
            tayyabmd00001@gmail.com
          </a>
          <p className=" py-8 mb-4">Phone/whatsapp: +8801644385198</p>

          <div className="  flex justify-center mx-auto">
            <a
              href="https://www.facebook.com/share/1KarL3hREi/"
              target="_blank"
              class="socialContainer w-14 my-5 h-14 rounded-xl m-1 containerThree"
              aria-label="Facebook"
            >
              <svg
                class="socialSvg facebookSvg"
                viewBox="0 0 16 16"
                fill="currentColor"
              >
                <path d="M12.728 0H3.272A3.272 3.272 0 0 0 0 3.272v9.456A3.272 3.272 0 0 0 3.272 16h5.093V9.845H6.773V7.41h1.592V5.803c0-1.578.964-2.44 2.373-2.44.673 0 1.252.05 1.419.073v1.645h-.973c-.763 0-.911.363-.911.895v1.167h1.822l-.237 2.434h-1.585V16h3.106A3.272 3.272 0 0 0 16 12.728V3.272A3.272 3.272 0 0 0 12.728 0z"></path>
              </svg>
            </a>
            <a
              href="https://wa.me/8801644385198"
              target="_blank"
              class="socialContainer w-14 my-5 h-14 rounded-xl m-1 containerFour"
            >
              <svg class="socialSvg whatsappSvg" viewBox="0 0 16 16">
                {" "}
                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>{" "}
              </svg>
            </a>
          </div>

          <button class="cursor-pointer group relative flex gap-1.5 mx-auto my-6 px-14 py-2 bg-lime-600 bg-opacity-70 text-[#f1f1f1] rounded-full hover:bg-opacity-0 transition font-semibold shadow-md">
            <Link to={"/contact"} className="font-bold tracking-wide  ">
              HIRE ME !
            </Link>
          </button>
          <button
            class="cursor-pointer animated-Btn group relative flex gap-1.5 mx-auto my-10 px-8 py-2 bg-black bg-opacity-70 text-[#f1f1f1] rounded-full hover:bg-opacity-0 transition font-semibold shadow-md"
            onClick={handleDownload}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              height="24px"
              width="24px"
            >
              <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
              <g
                stroke-linejoin="round"
                stroke-linecap="round"
                id="SVGRepo_tracerCarrier"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <g id="Interface / Download">
                  {" "}
                  <path
                    stroke-linejoin="round"
                    stroke-linecap="round"
                    stroke-width="2"
                    stroke="#f1f1f1"
                    d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12"
                    id="Vector"
                  ></path>{" "}
                </g>{" "}
              </g>
            </svg>
            Download CV
          </button>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.9,
            scale: { type: "spring", visualDuration: 0.6, bounce: 0.1 },
          }}
          className="md:hidden block mx-auto container py-10 px-5 rounded-2xl bg-gradient-to-r from-gray-500 to-lime-800  text-center"
        >
          <div className="profile-wrapper">
            {/* Rotating Border */}
            <motion.div
              className="profile-rotating-border"
              animate={{ rotate: 360 }}
              transition={{
                repeat: Infinity,
                duration: 6,
                ease: "linear",
              }}
            />

            {/* Static Image */}
            <div className="profile-image-holder">
              <img src={tayyab} alt="me" />
            </div>
          </div>
          <h2 className="Riesling md:text-3xl font-bold text-4xl py-8">
            Md Tayyab
          </h2>
          <a
            href="mailto:tayyabmd00001@gmail.com"
            className="font-bold py-8 my-4"
          >
            tayyabmd00001@gmail.com
          </a>
          <p className="font-bold py-8 my-4">Phone: +8801644385198</p>

          <div className="  flex justify-center mx-auto">
            <a
              href="https://www.facebook.com/share/1KarL3hREi/"
              target="_blank"
              class="socialContainer w-14 my-5 h-14 rounded-xl m-1 containerThree"
              aria-label="Facebook"
            >
              <svg
                class="socialSvg facebookSvg"
                viewBox="0 0 16 16"
                fill="currentColor"
              >
                <path d="M12.728 0H3.272A3.272 3.272 0 0 0 0 3.272v9.456A3.272 3.272 0 0 0 3.272 16h5.093V9.845H6.773V7.41h1.592V5.803c0-1.578.964-2.44 2.373-2.44.673 0 1.252.05 1.419.073v1.645h-.973c-.763 0-.911.363-.911.895v1.167h1.822l-.237 2.434h-1.585V16h3.106A3.272 3.272 0 0 0 16 12.728V3.272A3.272 3.272 0 0 0 12.728 0z"></path>
              </svg>
            </a>

            <a
              href="https://wa.me/8801644385198"
              target="_blank"
              class="socialContainer w-14 my-5 h-14 rounded-xl m-1 containerFour"
            >
              <svg class="socialSvg whatsappSvg" viewBox="0 0 16 16">
                {" "}
                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>{" "}
              </svg>
            </a>
          </div>

          <button class="cursor-pointer group relative flex gap-1.5 mx-auto my-6 px-14 py-2 bg-lime-600 bg-opacity-70 text-[#f1f1f1] rounded-full hover:bg-opacity-0 transition font-semibold shadow-md">
            <Link to={"/contact"} className="font-bold tracking-wide ">
              HIRE ME !
            </Link>
          </button>
          <button
            class="cursor-pointer animated-Btn group relative flex gap-1.5 mx-auto my-10 px-8 py-2 bg-black bg-opacity-70 text-[#f1f1f1] rounded-full hover:bg-opacity-0 transition font-semibold shadow-md"
            onClick={handleDownload}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              height="24px"
              width="24px"
            >
              <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
              <g
                stroke-linejoin="round"
                stroke-linecap="round"
                id="SVGRepo_tracerCarrier"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <g id="Interface / Download">
                  {" "}
                  <path
                    stroke-linejoin="round"
                    stroke-linecap="round"
                    stroke-width="2"
                    stroke="#f1f1f1"
                    d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12"
                    id="Vector"
                  ></path>{" "}
                </g>{" "}
              </g>
            </svg>
            Download CV
          </button>
        </motion.div>
      </div>
    );
};

export default Sidebar;